<div [class.input-group]="button">
    <input type="search" [id]="id ? id : null" [name]="name ? name : null" #searchTextInput 
        [class.form-control]="true" [class.searchTextInput]="true" [class]="class"
        [(ngModel)]="value" (search)="searchTextInput_SearchEvent($event)" 
        [placeholder]="placeholder" [disabled]="disabled" [readonly]="readonly" 
        [attr.autoFocus]="autofocus" autocomplete="off" />
    <button type="button" *ngIf="button" class="search-btn" (click)="searchButtonClick($event)">
        <i class="ds-icon-default-search" [attr.aria-label]="label"></i>
    </button>
</div>